/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var P;!function(P){P[P.HPR=1]="HPR",P[P.OPK=2]="OPK",P[P.YPR=3]="YPR",P[P.LTP=4]="LTP"}(P||(P={}));export{P as CameraOrientationType};
